(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('./wtx-first-order-engine.js'), require('./wtx-first-order-portions.js'));
  } else if (root) {
    root.WTXFirstOrderHorizon = factory(root.WTXFirstOrderEngine, root.WTXFirstOrderPortions);
  }
}(typeof window !== 'undefined' ? window : null, function (engine, portions) {
  'use strict';

  var MAX_SAFE = Number.MAX_SAFE_INTEGER;

  function positive(value) {
    return typeof value === 'number' && Number.isFinite(value) && value > 0 && value <= MAX_SAFE;
  }

  function identifier(value) {
    return (typeof value === 'string' && value.trim().length > 0) ||
      (Number.isSafeInteger(value) && value > 0);
  }

  function empty(error, requestedDays, basis) {
    return {
      lines: [], targetLb: 0, totalLb: 0, coverageDays: 0,
      coverageDaysLow: 0, coverageDaysHigh: 0, subtotal: 0,
      shippingExtraLb: 0, requestedDays: requestedDays || null,
      basis: basis || null, duration: null, sufficient: false, error: error
    };
  }

  function variantPounds(variant) {
    if (!variant || typeof variant !== 'object') return 0;
    if (variant.lb !== undefined) return positive(variant.lb) ? variant.lb : 0;
    if (typeof variant.title !== 'string') return 0;
    var match = variant.title.match(/^\s*(\d+(?:\.\d+)?)\s*(?:lbs?|pounds?)\b/i);
    return match ? Number(match[1]) : 0;
  }

  function planEstimate(input) {
    if (!engine || typeof engine.plan !== 'function' || !portions ||
        typeof portions.energy !== 'function' || typeof portions.estimate !== 'function' ||
        !positive(portions.lbToKg)) return empty('unavailable');
    if (!input || typeof input !== 'object') return empty('invalid_input');
    if (![30, 60, 90].includes(input.days)) return empty('invalid_days');
    var days = input.days;
    if (!['pickup', 'local', 'shipping'].includes(input.method)) return empty('invalid_method', days);
    var packSize = input.packSize === undefined ? 'small' : input.packSize;
    if (!['small', 'value'].includes(packSize)) return empty('invalid_pack_size', days);
    var energy = portions.energy(input.dogs);
    if (energy.error) return empty(energy.error, days);
    if (!Array.isArray(input.products) || input.products.length < 1 || input.products.length > 2) {
      return empty('invalid_products', days);
    }
    var firstShare = 1;
    if (input.products.length === 2) {
      var split = input.split === undefined ? 50 : input.split;
      if (typeof split === 'string' && /^\d+(?:\.\d+)?$/.test(split.trim())) split = Number(split);
      if (!positive(split) || split >= 100) return empty('invalid_split', days);
      firstShare = split / 100;
    }
    var ids = [];
    var weightedKcalPerKg = 0;
    var products = [];
    var shares = [];
    for (var i = 0; i < input.products.length; i += 1) {
      var product = input.products[i];
      if (!product || !identifier(product.id) || ids.includes(String(product.id)) || !Array.isArray(product.variants)) {
        return empty('invalid_products', days);
      }
      if (product.requiresPlan === true) return empty('individual_guidance', days);
      if (!positive(product.kcalPerKg)) return empty('unknown_calories', days);
      ids.push(String(product.id));
      var share = i === 0 ? firstShare : 1 - firstShare;
      shares.push({ productId: product.id, share: share });
      weightedKcalPerKg += product.kcalPerKg * share;
      products.push({
        id: product.id,
        share: share,
        variants: product.variants.map(function (variant) {
          return variant ? {
            id: variant.id,
            lb: variantPounds(variant),
            price: variant.price,
            available: variant.available
          } : null;
        })
      });
    }
    var targetDailyOz = energy.dailyKcalHigh / (weightedKcalPerKg * portions.lbToKg) * 16;
    if (!positive(weightedKcalPerKg) || !positive(targetDailyOz)) return empty('invalid_amount', days);
    var basis = {
      kind: 'upper_calorie_range',
      purpose: 'Stock planning, not a prescribed feeding amount or a complete-diet claim.',
      dailyKcalLow: energy.dailyKcalLow,
      dailyKcalHigh: energy.dailyKcalHigh,
      targetDailyOz: targetDailyOz,
      requestedWeightShares: shares,
      weightedKcalPerKg: weightedKcalPerKg,
      interpolated: energy.interpolated,
      source: portions.source
    };
    var planned = engine.plan({
      dailyOz: targetDailyOz,
      days: days,
      packSize: packSize,
      shipping: input.method === 'shipping',
      products: products
    });
    if (planned.error) return Object.assign(empty(planned.error, days, basis), {
      targetLb: planned.targetLb || 0,
      shippingExtraLb: planned.shippingExtraLb || 0
    });
    var duration = portions.estimate({dogs: input.dogs, lines: planned.lines, products: input.products});
    if (duration.error) return empty(duration.error, days, basis);
    var sufficient = duration.coverageDaysLow + 1e-8 >= days;
    if (!sufficient || input.method === 'shipping' && duration.totalLb < 40) {
      return Object.assign(empty(sufficient ? 'shipping_minimum' : 'insufficient_duration', days, basis), {
        targetLb: planned.targetLb,
        shippingExtraLb: planned.shippingExtraLb,
        duration: duration
      });
    }
    return Object.assign({}, planned, {
      requestedDays: days,
      coverageDays: duration.coverageDaysLow,
      coverageDaysLow: duration.coverageDaysLow,
      coverageDaysHigh: duration.coverageDaysHigh,
      totalLb: duration.totalLb,
      subtotal: duration.subtotal,
      basis: basis,
      duration: duration,
      sufficient: true
    });
  }

  return Object.freeze({planEstimate: planEstimate});
}));
